
export default {
  namespaced: true,

  state: () => ({
    breadCrumbs: []
  }),

  getters: {
    getBreadCrumbs: state => state.breadCrumbs,
  },

  mutations: {
    setBreadCrumbs: (state, payload = []) => {
      state.breadCrumbs = payload;
    },
  },

  actions: {
    loadBreadCrumbs({ rootState, commit }, { categoryUrl = rootState.route.path } = {}) {
      if (!['Catalog', 'Category'].includes(rootState.route.name)) {
        return Promise.resolve([]);
      }
      return this.$api.loadBreadCrumbs({ categoryUrl })
        .then(data => {
          commit('setBreadCrumbs', data);
        })
        .catch(() => {
          commit('setBreadCrumbs');
        })
    }
  }
}
